import 'preact/debug';
import InitWidget from './widgets/InitWidget';
const widgetDefinition = [
    { selector: '.booking-form', moduleName: 'BookingForm' },
    { selector: '[data-component="diy-day-tickets"]', moduleName: 'DIYDayTickets' },
    { selector: '.activity-selector-form', moduleName: 'ActivitySelector' },
    { selector: '[data-component="basket"]', moduleName: 'Basket' },
    { selector: '[data-component="day-tickets"]', moduleName: 'DayTickets' },
    { selector: '[data-component="account-page"]', moduleName: 'AccountPage' },
    {
        selector: '[data-component="enquiry-form"]',
        moduleName: 'EnquiryForm',
        callbackFn: (element) => {
            element.removeAttribute('data-fields');
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="login-modal"]',
        moduleName: 'LoginModal',
        callbackFn: (element) => {
            element.removeAttribute('data-fields');
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="price-input"]',
        moduleName: 'PriceInput',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="newsletter-registration"]',
        moduleName: 'NewsletterRegistration',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="login-form"]',
        moduleName: 'LoginForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="misc-products"]',
        moduleName: 'MiscProducts',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="logout-modal"]',
        moduleName: 'LogoutModal',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="reset-password-form"]',
        moduleName: 'ResetPasswordForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="resubscribe-form"]',
        moduleName: 'ResubscribeForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="forgot-password"]',
        moduleName: 'ForgotPassword',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="account-form"]',
        moduleName: 'AccountForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="register-form"]',
        moduleName: 'RegisterForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
            element.removeAttribute('data-action');
        },
    },
    {
        selector: '[data-component="voucher-form"]',
        moduleName: 'VoucherForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="basket-sidebar"]',
        moduleName: 'BasketSidebar',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="basket-list"]',
        moduleName: 'BasketList',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="stepped-quiz"]',
        moduleName: 'SteppedQuiz',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="membership-form"]',
        moduleName: 'MembershipForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="direct-debit-form"]',
        moduleName: 'DirectDebitForm',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="quick-pay"]',
        moduleName: 'QuickPayWrapper',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="wallet"]',
        moduleName: 'WalletWrapper',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    // { selector: '.generic-form', moduleName: 'GenericForm' },
    {
        selector: '[data-component="search"]',
        moduleName: 'SiteSearch',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="upsell-modal"]',
        moduleName: 'UpsellModal',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
    {
        selector: '[data-component="retention-modal"]',
        moduleName: 'RetentionModal',
        callbackFn: (element) => {
            element.removeAttribute('data-component');
        },
    },
];
const widgets = {
    bootstrap: {
        init: () => {
            (widgetDefinition ?? []).forEach(({ selector, moduleName, callbackFn }) => {
                (document.querySelectorAll(selector) ?? []).forEach((el) => {
                    const widget = new InitWidget(el, moduleName);
                    window.addEventListener('widget.loaded', (ev) => {
                        if (callbackFn && (ev.detail.widget === moduleName)) {
                            callbackFn(ev.detail.element);
                        }
                    });
                    return widget;
                });
            });
            window.addEventListener('init.widget', (ev) => {
                if (ev.detail.element) {
                    return new InitWidget(ev.detail.element, ev.detail.widget);
                }
                return false;
            });
        },
    },
};
document.addEventListener('DOMContentLoaded', () => widgets.bootstrap.init());
